import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AppDevelopmentIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_506_3684)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.1496 12.2625L15.8084 11.8313C16.0139 11.8155 16.22 11.8546 16.4056 11.9445C16.5912 12.0344 16.7496 12.1719 16.8647 12.343C16.9797 12.5141 17.0473 12.7127 17.0606 12.9185C17.0738 13.1242 17.0323 13.3298 16.9401 13.5143C16.8081 13.7773 16.5818 13.9808 16.3064 14.0843L8.48085 17.0183C7.99885 17.1994 7.46922 17.2092 6.98085 17.046L0.985352 15.048",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M4.92285 12.798H9.26385C9.47386 12.798 9.67853 12.7319 9.84893 12.6092C10.0193 12.4864 10.1468 12.3132 10.2134 12.114C10.2563 11.9849 10.2724 11.8484 10.2609 11.7128C10.2493 11.5773 10.2102 11.4455 10.1459 11.3255C10.0817 11.2056 9.99372 11.1 9.88732 11.0152C9.78092 10.9304 9.65835 10.8681 9.5271 10.8323L5.0736 9.61803C4.60361 9.48943 4.11139 9.46384 3.6306 9.54303L0.985352 9.98403",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M6.54735 2.22461L3.79785 4.28711L6.54735 6.34961",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M13.4229 2.22461L16.1731 4.28711L13.4229 6.34961",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M10.6726 0.849121L9.29785 7.72437",
                        stroke: "#6161FF",
                        strokeWidth: "1.25",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_506_3684",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "18",
                        height: "18",
                        fill: "white"
                    })
                })
            })
        ]
    });
